import React from "react";
import Skeleton from "../../../../components/skeleton";
import { findIcon } from "../../../../views/dashboard/icons";

const CommentSkeleton = () => {
  return (
    <div className="row border-bottom border-2 align-items-center m-3 p-2">
      <div className="col-md-1">
        <div className="opacity-50">{findIcon("Quote", "dual-tone", 36)}</div>
      </div>
      <div className="col-md-5">
        <Skeleton variant="text" width={120} height={200} className="h-100" />
        <Skeleton variant="text" width={150} height={200} className="h-100" />
      </div>
      <div className="col-md-3">
        <Skeleton variant="text" width={100} height={100} className="w-100" />
      </div>
      <div className="col-md-3">
        <Skeleton variant="text" width={100} className="w-100" />
        <Skeleton variant="text" width={100} className="w-50" />
      </div>
    </div>
  );
};

export default CommentSkeleton;
